export const passCodeMessageByType = {
	CPF: 'Digite os 5 primeiros dígitos do seu CPF',
	FOREIGN_PASSPORT: 'Digite o número do seu Passaporte',
	CRNM: 'Digite o número da sua Carteira Nacional de Registro Migratório'
};
